(() => {
  if (window.gridoneContactInstalled) return;
  window.gridoneContactInstalled = true;
  function init(root) {
    for (const panel of root.querySelectorAll('[data-gridone-contact]')) {
      if (panel.dataset.initialized) continue;
      panel.dataset.initialized = 'true';
      const select = panel.querySelector('[data-gridone-interest]');
      const detail = panel.querySelector('[data-gridone-detail]');
      const params = new URLSearchParams(window.location.search);
      let rawInterest = (params.get('interesse') || '').slice(0, 200);
      const blockedInterest = (panel.dataset.gridoneRental !== 'true' && ['groups','booking','rental'].includes(rawInterest)) || (panel.dataset.gridoneTraining !== 'true' && ['training','simulatortrening'].includes(rawInterest));
      if (blockedInterest) rawInterest = 'other';
      const aliases = {kit:'turnkey',upgrade:'equipment',wheels:'equipment',pedals:'equipment',cockpit:'equipment',motion:'equipment',accessories:'equipment'};
      const interest = aliases[rawInterest] || rawInterest;
      const details = {kit:'Simulatorpakke for selvbygg',upgrade:'Oppgradering av simulator',wheels:'Ratt og rattbase',pedals:'Pedaler',cockpit:'Cockpit og sete',motion:'Motion',accessories:'Tilbehør'};
      const product = blockedInterest ? '' : (params.get('produkt') || details[rawInterest] || '').slice(0, 200);
      if (select && interest && !select.value) {
        const option = Array.from(select.options).find(item =>
          item.dataset.interestKey === interest || item.value.toLocaleLowerCase('nb') === interest.toLocaleLowerCase('nb'));
        if (option) {
          select.value = option.value;
          select.dispatchEvent(new Event('change', {bubbles: true}));
        } else {
          const other = Array.from(select.options).find(item => item.dataset.interestKey === 'other');
          if (other) select.value = other.value;
        }
        if (detail && !detail.value) detail.value = product || (option ? '' : interest);
      } else if (detail && product && !detail.value) detail.value = product;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();
